// extracted by mini-css-extract-plugin
export default {"form":"BvSoolN7DHuWVURAZy91","content":"qcbGB7dEsVTUa81sSwm8"};